window.Cart = {
	updateTotals: function (data) {
		var upd = function (data) {
			if (data.total_view) {
				$cont = $('.form-make-order .table-totals');
				$cont.after(data.total_view);
				$cont.remove();
			}
		};

		if (data) {
			upd(data);
		} else {
			$.get('/cart/get_totals', this.formParams(), function (data) {
				upd(data);
			});
		}
	},
	updateTotalsMinicart: function(data) {
		if (data.total_view) {
			$minicartTotal = $('.offcanvas-minicart-wrapper .minicart-pricing-box');
			$minicartTotal.after(data.total_view);
			$minicartTotal.remove();
		}
	},
	formParams: function (append) {
		var params = append || {};
		var formParams = $("#form-make-order").serializeArray();

		for(var i = 0; i < formParams.length; i++) {
			params[formParams[i].name] = formParams[i].value;
		}

		return params;
	},
	showModalAdded: function(title) {
		$modal = $('#added-cart');

		$modal.find('h3 span').text(title);
		$modal.modal('show');
	},
	updateCnt: function (cnt) {
		$('.minicart-btn .notification, .mini-cart-wrap .notification').text(cnt).show();
	}
};